// extracted by mini-css-extract-plugin
export default {"content":"AbsenceRequestModal_content__vTdOi","calendarBox":"AbsenceRequestModal_calendarBox__lvmKs","formSection":"AbsenceRequestModal_formSection__MGbQE"};